import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Shape Trail',
    description:
        'An interactive geometric canvas where your cursor paints shapes in warm earth tones. Move to bloom forms, hover to morph them, click to burst.',
    url: 'https://shapetrail.com'
}